import request from '@/utils/request'

export function list(data) {
    data.json  = true
    let url = '/doc/down/list'
    return request.post(url,data)
}

export function all() {
    let url = '/doc/down/all'
    return request.get(url)
}

export function down(data) {
    data.json  = true
    let config = {
        responseType: 'arraybuffer',
    }
    let url =  '/doc/down/down'
    return request.post(url,data,config)
}

export function info(id) {
    let url = '/doc/down/info/' + id
    return request.get(url)
}

export function save(data) {
    data.json = true
    let url = '/doc/down/save'
    return request.post(url,data)
}

export function update(data) {
    data.json = true
    let url = '/doc/down/update'
    return request.post(url,data)
}

export function remove(data) {
    let url =  '/doc/down/delete'
    return request.post(url,data)
}

export function options() {
    let url =  '/doc/down/dmz/options'
    return request.get(url)
}
